import styled from 'styled-components';
import { ReactComponent as Ok } from '../../assets/icons/ok.svg';

export const NoContent = styled.div`
    background:${props => props.theme.colors.primaryDark1};
    height:386px;
    padding:20px;
    display:flex;
    justify-content:center;
    align-items:center;

    @media screen and (max-width:960px){
        height:185px;
    }
`;

export const Container = styled.div`
    display:flex;
    flex-direction:column;
    align-items:center;
`;

export const Message = styled.h2`
    font-weight:400;
    font-size:32px;
    margin-top:23px;
    color:${props => props.theme.colors.white};  

    @media screen and (max-width:960px){
        margin-top:22px;
        text-align:center;
        font-size:20px;
    }
`;

export const IconOk = styled(Ok)`
    width:68px;
    height:68px;

    @media screen and (max-width:960px){
        width:44px;
        height:44px;
    }
`;